import apiData from 'Lib/apiData';

const fetchProgramList = async (endpoint, data, fieldId) => {
  if (!data || (data[0] && data[0].fields && !data[0].fields[fieldId])) return;

  const programs = data[0].fields[fieldId].map(program => program.sys.id).join(',');
  const featuredPrograms = await apiData(endpoint, { cids: programs, status: 'published' });

  return featuredPrograms.items.filter(Boolean);
};

export default fetchProgramList;
